
export default function Footer() {
  return (
    <footer className="bg-primary text-white py-16 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="text-2xl font-bold mb-4">Kinra Health</div>
            <p className="text-white/80 text-sm leading-relaxed">
              AI-enabled retinal screening to close diabetic eye exam care gaps at scale.
            </p>
          </div>

          {/* Empty Column */}
          <div></div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="/about-us" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="/our-process" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm">
                  Our Process
                </a>
              </li>
              <li>
                <a href="/who-we-work-with" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm">
                  Who We Work With
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Get Started</h4>
            <ul className="space-y-3">
              <li>
                <a href="/contact" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm">
                  Request a Demo
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm">
            © {new Date().getFullYear()} Kinra Health. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
